// start:ng42.barrel
export * from './write-review-hotel-info.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/write-review-hotel-info/index.ts